<script>
export default {
  name: 'PageTitle',
  props: ['title', 'explainText']
}
</script>
<template>
  <div class="padding-x padding-y gradient-01-fill fg-1 big-body">
    <div class="max-1200">
      <div class="page-title">
        {{title}}
      </div>
      <div v-if="explainText">
        <div class="gap-3x" />
        <div class="explain-text">{{explainText}}</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.page-title {
  font-family: Inter;
  font-size: 36px;
  letter-spacing: -0.01125em;  /* 36/3200 */
  line-height: 48px;
  font-weight: 600;
}

.explain-text {
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.005em;
}
</style>
